module.exports = __webpack_public_path__ + "img/img-1.a828a85d.png";